import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;

import { useCallback, useMemo, useRef, useEffect, useState } from 'react';
import { useQuestionContext } from '../core';
import { RichTextEditor, getSize, getColor, AppModal, NumberInput, SingleSelectInput, TextLinkButton, PrimaryButton, SecondaryButton } from '@lib/common';
import styled, { getShadow } from '@xstyled/styled-components';
import { Form, Space, Skeleton } from 'antd';
import { QuestionType, Size, RequestStatus } from '@module/form';
import Image from 'next/image';
import { Tooltip } from 'antd';
import { AudioFileEdit, AudioFileContainerDirection } from '../../audio-file';
import { questionTypeSwitchManager } from '../domain/strategies';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledLayout = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  box-shadow: ", ";\n  background-color: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  overflow: hidden;\n\n  border-width: 1px 1px 1px 6px;\n  border-style: solid;\n  border-color: ", ";\n\n  transition: border-color 0.3s ease;\n"])), getSize('padding24'), getShadow('shadow1'), getColor('fillBgWhite'), getSize('padding24'), getSize('radiusSm'), function (_ref) {
  var $selected = _ref.$selected;
  return $selected ? getColor('fillIntActive') : '#cbd5e1';
});
var StyledHeaderContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var StyledQuestionNumberTag = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", " ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background: #dbeafe;\n  border-radius: ", ";\n  font-weight: 700;\n  text-transform: uppercase;\n  flex-shrink: 0;\n  user-select: none;\n"])), getSize('padding2'), getSize('padding8'), getSize('typo12'), getSize('typo16'), getColor('fillIntActive'), getSize('radiusS'));
var StyledHeaderControls = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n\n  .ant-form-item {\n    margin-bottom: 0;\n  }\n"])), getSize('padding12'));
var StyledScoreInput = styled(NumberInput)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 140px;\n\n  .ant-input-number-group-addon {\n    border-top-right-radius: ", " !important;\n    border-bottom-right-radius: ", " !important;\n    background-color: transparent;\n    color: #475569;\n    font-weight: 500;\n    border-left: none;\n  }\n\n  .ant-input-number {\n    border-top-left-radius: ", " !important;\n    border-bottom-left-radius: ", " !important;\n    border-color: #cbd5e1;\n\n    &:hover,\n    &:focus,\n    &-focused {\n      border-color: ", ";\n    }\n  }\n\n  .ant-input-number-group-wrapper {\n    height: 40px;\n    .ant-input-number-wrapper {\n      height: 100%;\n      .ant-input-number {\n        height: 100%;\n        display: flex;\n        align-items: center;\n      }\n    }\n  }\n"])), getSize('radiusS'), getSize('radiusS'), getSize('radiusS'), getSize('radiusS'), getColor('fillIntActive'));
var StyledActionButtonWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n"])));
var StyledDeleteIcon = styled(Image)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  transition: opacity 0.2s ease;\n"])));
var MediaWrapper = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral([""])));
var StyledChildrenWrapper = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding16'));
var StyledContentWrapper = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding16'));
var StyledExplanationWrapper = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  padding: ", ";\n  background-color: #faf8fc;\n  border-radius: ", ";\n  border: 1px solid #f3e8ff;\n"])), getSize('padding12'), getSize('padding16'), getSize('radiusSm'));
var StyledExplanationHeader = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n\n  font-size: ", ";\n  font-weight: 700;\n  color: #1e293b;\n"])), getSize('padding8'), getSize('typo16'));
var StyledExplanationEditorWrapper = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  .tiptap {\n    background-color: white !important;\n  }\n"])));
var StyledGroupButton = styled(Space)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row-reverse;\n"]))); // Helper function to check if description is empty (after removing HTML tags and whitespace)

var isDescriptionEmpty = function isDescriptionEmpty(description) {
  if (!description) return true; // Remove all whitespace

  var contentWithoutWhitespace = description.replace(/\s/g, ''); // Remove all HTML tags

  var htmlTagRegex = /(<([^>]+)>)/gi;
  var formattedContentWithoutHTML = contentWithoutWhitespace.replaceAll(htmlTagRegex, ''); // Check if content is empty after removing HTML and whitespace

  return !formattedContentWithoutHTML || formattedContentWithoutHTML.length === 0;
};

export var BaseQuestionEditComponent = function BaseQuestionEditComponent(_ref2) {
  var states = _ref2.states,
      actions = _ref2.actions,
      children = _ref2.children,
      audioEdit = _ref2.audioEdit,
      hasGuide = _ref2.hasGuide,
      openGuide = _ref2.openGuide;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var isSelected = states.isSelected,
      label = states.label,
      icon = states.icon,
      readonly = states.readonly,
      textEditorCustomMenuItems = states.textEditorCustomMenuItems,
      textEditorMenuGroupsOrder = states.textEditorMenuGroupsOrder,
      textEditorCustomExtensions = states.textEditorCustomExtensions,
      editorLabels = states.editorLabels,
      audioLabel = states.audioLabel,
      selectedFile = states.selectedFile,
      addQuestionFileStatus = states.addQuestionFileStatus,
      _states$isQuestionSwi = states.isQuestionSwitching,
      isQuestionSwitching = _states$isQuestionSwi === void 0 ? false : _states$isQuestionSwi,
      _states$activeEditorT = states.activeEditorType,
      activeEditorType = _states$activeEditorT === void 0 ? 'description' : _states$activeEditorT,
      isValidForSave = states.isValidForSave;
  var onUpdateDescription = actions.onUpdateDescription,
      onUpdateExplanation = actions.onUpdateExplanation,
      onUpdateScore = actions.onUpdateScore,
      onUpdateType = actions.onUpdateType,
      onDelete = actions.onDelete,
      onAddImage = actions.onAddImage,
      onAddAudio = actions.onAddAudio,
      onDeleteAudio = actions.onDeleteAudio,
      onSave = actions.onSave,
      onCancel = actions.onCancel;
  var isSaving = states.isSaving,
      isCancelling = states.isCancelling; // Internal state for managing type switch loading

  var _useState = useState(false),
      isSwitching = _useState[0],
      setIsSwitching = _useState[1];

  var previousQuestionTypeRef = useRef(question.type); // Detect when question type actually changes (end of switching)

  useEffect(function () {
    if (previousQuestionTypeRef.current !== question.type) {
      // Type has changed, stop loading
      setIsSwitching(false);
      previousQuestionTypeRef.current = question.type;
    }
  }, [question.type]);
  /**
   * Helper: Check if confirmation should be shown for destructive changes
   */

  var shouldShowConfirmation = useCallback(function (result) {
    return result.shouldClearAnswers || !result.shouldPreserveDescription;
  }, []);
  /**
   * Helper: Get confirmation message based on what will be changed
   */

  var getConfirmationMessage = useCallback(function (result) {
    var warnings = [];

    if (result.shouldClearAnswers) {
      warnings.push(label.warningClearAnswers || 'All answers will be cleared');
    }

    if (!result.shouldPreserveDescription) {
      warnings.push(label.warningResetDescription || 'Description will be reset to default');
    }

    return warnings.join('. ') + '. Continue?';
  }, [label]);
  /**
   * Main handler for question type changes using Strategy Pattern (Option 2)
   *
   * Strategy Pattern is used as a pre-processor to:
   * - Get metadata about what will happen
   * - Show confirmation for destructive changes
   * - Provide better UX with warnings
   *
   * Actual switching logic is handled by Domain Layer (Question.cloneNewType)
   *
   * @param fromType - Current question type
   * @param toType - Target question type
   */

  var onQuestionTypeChange = useCallback(function (fromType, toType) {
    // Early return if same type
    if (fromType === toType) {
      return;
    } // Get strategy result (metadata about what will happen)


    var switchResult = questionTypeSwitchManager.executeSwitch(fromType, toType);

    if (!switchResult) {
      console.error("[QuestionTypeSwitch] Failed to get switch strategy from ".concat(fromType, " to ").concat(toType));
      return;
    }
    /**
     * Execute the actual switch
     * This calls the Domain Use Case which triggers:
     * - Question.cloneNewType() - preserves common fields
     * - Question.cloneExtendedProps() - handles answers based on type
     */


    var executeSwitch = function executeSwitch() {
      // Start skeleton loading
      setIsSwitching(true); // Store the previous type

      previousQuestionTypeRef.current = fromType; // Call domain use case - THIS IS WHERE REAL LOGIC HAPPENS
      // Domain layer handles all the actual switching logic

      onUpdateType(question.id.toString(), toType); // Note: Skeleton will be hidden when question type actually changes
      // (detected by the useEffect above)
    }; // Show confirmation modal if there are destructive changes


    if (shouldShowConfirmation(switchResult)) {
      AppModal.confirm({
        title: label.confirmChangeQuestionType || 'Change Question Type',
        content: getConfirmationMessage(switchResult),
        okText: label.confirm,
        cancelText: label.cancel,
        onOk: executeSwitch
      });
    } else {
      // Non-destructive changes: execute immediately with skeleton
      executeSwitch();
    }
  }, [question.id, onUpdateType, label, shouldShowConfirmation, getConfirmationMessage]);
  /**
   * Wrapper for the SelectInput onChange handler
   * Extracts current type and calls main handler
   */

  var handleQuestionTypeChange = useCallback(function (newType) {
    var currentType = question.type;
    onQuestionTypeChange(currentType, newType);
  }, [question.type, onQuestionTypeChange]); // Check if description is empty to disable save button

  var isDescriptionEmptyValue = useMemo(function () {
    return isDescriptionEmpty(question.description);
  }, [question.description]);
  var editorRef = useRef(null);
  var explanationEditorRef = useRef(null);
  var insertedFileIdRef = useRef(null); // Insert image into editor after upload success and update draft question

  useEffect(function () {
    if (addQuestionFileStatus === RequestStatus.SUCCESS && selectedFile && selectedFile.url && insertedFileIdRef.current !== selectedFile.id.toString() && // Prevent duplicate insertion
    activeEditorType !== 'answer' // Skip if uploading for answer description (handled by answer component)
    ) {
      // Determine which editor to insert into based on activeEditorType
      var targetRef = activeEditorType === 'explanation' ? explanationEditorRef : editorRef;

      if (targetRef.current) {
        // Insert image into the correct editor
        targetRef.current.insertImageHandler(selectedFile.url);
        insertedFileIdRef.current = selectedFile.id.toString();
      }
    } // Reset inserted file ID when status changes to RESET or when file changes


    if (addQuestionFileStatus === RequestStatus.RESET) {
      insertedFileIdRef.current = null;
    }
  }, [addQuestionFileStatus, selectedFile, activeEditorType]);
  var questionTypeOptions = [{
    label: label.singleChoice || 'Single Choice',
    value: QuestionType.SingleChoice
  }, {
    label: label.multipleChoice || 'Multiple Choice',
    value: QuestionType.MultipleChoice
  }, {
    label: label.fillInBlank || 'Fill in Blank',
    value: QuestionType.FillInBlank
  }, {
    label: label.essay || 'Essay',
    value: QuestionType.Essay
  }, {
    label: label.speaking || 'Speaking',
    value: QuestionType.Speaking
  }, {
    label: label.matching || 'Matching',
    value: QuestionType.Matching
  }];
  var handleDelete = useCallback(function () {
    AppModal.confirm({
      title: label.confirmDeleteQuestion,
      content: label.doYouWantToContinueDoingThis,
      okText: label.confirm,
      cancelText: label.cancel,
      onOk: function onOk() {
        return onDelete(question.id.toString());
      }
    });
  }, [label, onDelete, question]);
  var isScoreDisabled = useMemo(function () {
    return question.type === QuestionType.FillInBlank || question.type === QuestionType.Matching;
  }, [question.type]);
  var audioFile = question === null || question === void 0 ? void 0 : question.audioFile; // Determine if we should show skeleton (from state or internal)

  var showSkeleton = isQuestionSwitching || isSwitching;
  return /*#__PURE__*/_jsxs(StyledLayout, {
    $selected: !!isSelected,
    children: [/*#__PURE__*/_jsxs(StyledHeaderContainer, {
      children: [/*#__PURE__*/_jsxs(Space, {
        size: 12,
        children: [/*#__PURE__*/_jsxs(StyledQuestionNumberTag, {
          children: [label.question, " ", question.titleIndex]
        }), /*#__PURE__*/_jsx(Form.Item, {
          noStyle: true,
          children: /*#__PURE__*/_jsx(SingleSelectInput, {
            options: questionTypeOptions,
            value: question.type,
            onChange: function onChange(val) {
              return handleQuestionTypeChange(val);
            },
            style: {
              minWidth: 165
            },
            disabled: readonly || showSkeleton
          })
        })]
      }), /*#__PURE__*/_jsxs(StyledHeaderControls, {
        children: [/*#__PURE__*/_jsx(Form.Item, {
          noStyle: true,
          children: /*#__PURE__*/_jsx(StyledScoreInput, {
            min: 0,
            max: 100,
            step: "0.25",
            controls: true,
            value: question.score,
            onChange: function onChange(val) {
              return onUpdateScore(question.id.toString(), Number(val));
            },
            addonAfter: label.points,
            disabled: readonly || isScoreDisabled,
            stringMode: true
          })
        }), /*#__PURE__*/_jsx(Tooltip, {
          title: label["delete"],
          placement: "bottom",
          children: /*#__PURE__*/_jsx(StyledActionButtonWrapper, {
            onClick: handleDelete,
            $disabled: readonly,
            children: /*#__PURE__*/_jsx(StyledDeleteIcon, {
              src: "/icons/delete.svg",
              width: 16,
              height: 16,
              alt: "delete"
            })
          })
        })]
      })]
    }), hasGuide && /*#__PURE__*/_jsx(Space, {
      style: {
        marginBottom: 16
      },
      children: /*#__PURE__*/_jsx(TextLinkButton, {
        type: "link",
        title: label.guideline,
        icon: /*#__PURE__*/_jsx(Image, {
          src: "/icons/guide.svg",
          width: 20,
          height: 20,
          alt: "calendar-info"
        }),
        onClick: openGuide
      })
    }), audioFile && /*#__PURE__*/_jsx(MediaWrapper, {
      children: /*#__PURE__*/_jsx(AudioFileEdit, {
        source: audioFile.url,
        onEdit: function onEdit() {
          onAddAudio === null || onAddAudio === void 0 ? void 0 : onAddAudio(question.id.toString());
        },
        fileName: audioFile.name,
        fileSize: Size.format(audioFile.size),
        label: audioLabel,
        onDelete: onDeleteAudio,
        direction: AudioFileContainerDirection.HORIZONTAL
      }, audioFile.id.toString())
    }), audioEdit && !audioFile && /*#__PURE__*/_jsx(MediaWrapper, {
      children: audioEdit
    }), showSkeleton ? /*#__PURE__*/_jsx(Skeleton, {
      active: true,
      paragraph: {
        rows: 6
      }
    }) : /*#__PURE__*/_jsxs(StyledContentWrapper, {
      children: [/*#__PURE__*/_jsx(RichTextEditor, {
        ref: editorRef,
        content: question.description,
        onChange: function onChange(val) {
          return onUpdateDescription(question.id.toString(), val);
        },
        onUpdate: function onUpdate(val) {
          var _actions$onUpdateDesc;

          return (_actions$onUpdateDesc = actions.onUpdateDescriptionImmediate) === null || _actions$onUpdateDesc === void 0 ? void 0 : _actions$onUpdateDesc.call(actions, question.id.toString(), val);
        },
        onEditorReady: actions.onEditorReady,
        customMenuItems: textEditorCustomMenuItems,
        menuGroupsOrder: textEditorMenuGroupsOrder,
        customExtensions: textEditorCustomExtensions,
        placeholder: label.descriptionPlaceholder,
        disabled: readonly,
        addImage: function addImage() {
          return onAddImage === null || onAddImage === void 0 ? void 0 : onAddImage(question.id.toString());
        },
        addAudio: function addAudio() {
          return onAddAudio === null || onAddAudio === void 0 ? void 0 : onAddAudio(question.id.toString());
        },
        editorLabels: editorLabels
      }), children ? /*#__PURE__*/_jsx(StyledChildrenWrapper, {
        children: children
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    }), /*#__PURE__*/_jsxs(StyledExplanationWrapper, {
      children: [/*#__PURE__*/_jsxs(StyledExplanationHeader, {
        children: [icon.lightBulb, label.explanation]
      }), /*#__PURE__*/_jsx(StyledExplanationEditorWrapper, {
        children: /*#__PURE__*/_jsx(RichTextEditor, {
          ref: explanationEditorRef,
          content: question.explanation,
          onChange: function onChange(val) {
            return onUpdateExplanation(question.id.toString(), val);
          },
          onUpdate: function onUpdate(val) {
            return onUpdateExplanation(question.id.toString(), val);
          },
          placeholder: label.explanationPlaceholder,
          disabled: readonly,
          addImage: function addImage() {
            return onAddImage === null || onAddImage === void 0 ? void 0 : onAddImage(question.id.toString(), 'explanation');
          },
          editorLabels: editorLabels
        })
      })]
    }), /*#__PURE__*/_jsxs(StyledGroupButton, {
      children: [/*#__PURE__*/_jsx(Tooltip, {
        title: isSaving || isCancelling || isDescriptionEmptyValue || showSkeleton || isValidForSave !== undefined && !isValidForSave ? 'Some required fields are not filled' : '',
        children: /*#__PURE__*/_jsx("span", {
          style: {
            display: 'inline-block',
            width: '100%'
          },
          children: /*#__PURE__*/_jsx(PrimaryButton, {
            onClick: onSave,
            loading: isSaving,
            disabled: isSaving || isCancelling || isDescriptionEmptyValue || showSkeleton || isValidForSave !== undefined && !isValidForSave,
            style: {
              width: '100%'
            },
            children: label.save
          })
        })
      }), /*#__PURE__*/_jsx(SecondaryButton, {
        onClick: onCancel,
        loading: isCancelling,
        disabled: isSaving || isCancelling || showSkeleton,
        children: label.cancel
      })]
    })]
  });
};